import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { ChevronDown, ChevronRight } from "react-bootstrap-icons";

const FolderNode = ({
  node,
  level,
  selectionMode,
  selectedFolderId,
  setSelectedFolderId,
  currentFolderId,
  expandedFolders,
  toggleFolder,
  type,
}) => {
  const isOpen = expandedFolders.includes(node?.id);
  const handleToggle = () => toggleFolder(node?.id);
  const hasChildren = node?.children && node?.children.length > 0;
  const [typeofAction, setTypeofAction] = useState("");

  useEffect(() => {
    setTypeofAction(type)
  },[type]);

  const handleSelectionChange = () => {
    if (selectionMode === "multiple") {
      // Multi-select logic
      setSelectedFolderId((prev) =>
        prev.includes(node?.id)
          ? prev.filter((id) => id !== node?.id)
          : [...prev, node?.id]
      );
    } else {
      // Single-select logic
      setSelectedFolderId(node?.id);
    }
  };

  return (
    <li className="indi-folder-tree-content-list-item">
      <div className="indi-folder-tree-content-list-item-wrapper">
        <span className="indi-folder-tree-content-toggle-button-wrapper">
          {hasChildren && (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                handleToggle();
              }}
              className="indi-folder-tree-content-toggle-button"
              style={{ lineHeight: 1 }}
            >
              <span className={`indi-folder-tree-content-toggle-button-arrow`}>
                {isOpen ? (
                  <ChevronDown className="indi-custom-icon transition-rotate" />
                ) : (
                  <ChevronRight className="indi-custom-icon transition-rotate" />
                )}
              </span>
            </button>
          )}
        </span>
        <Form.Check
          className="indi-tree-node-checkbox"
          type="checkbox"
          id={`folder-${node?.id}`}
          name={
            selectionMode === "multiple"
              ? `folder-${node?.id}`
              : "folder-selection"
          }
          value={node.key}
          checked={
            selectionMode === "multiple"
              ? selectedFolderId.includes(node?.id)
              : selectedFolderId === node?.id
          }
          onChange={handleSelectionChange}
          disabled={typeofAction === "move" && node?.id === currentFolderId}
        />
        <label htmlFor={`folder-${node?.id}`}>{node?.name}</label>
      </div>

      {isOpen && hasChildren && (
        <ul className="indi-folder-tree-content-list">
          {node.children.map((child) => (
            <FolderNode
              key={child?.id}
              node={child}
              level={level + 1}
              selectionMode={selectionMode}
              selectedFolderId={selectedFolderId}
              setSelectedFolderId={setSelectedFolderId}
              currentFolderId={currentFolderId}
              expandedFolders={expandedFolders}
              toggleFolder={toggleFolder}
              type={type}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default FolderNode;
